import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcThreePointMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "xMidYMid meet",
	height: 12,
	width: 12,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	className: "shade-10-on-active",
	style: { verticalAlign: "middle" },
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M8 4C9.10455 4 10 3.10457 10 2C10 0.895431 9.10455 0 8 0C6.89545 0 6 0.895431 6 2C6 3.10457 6.89545 4 8 4ZM8 10C9.10455 10 10 9.10457 10 8C10 6.89543 9.10455 6 8 6C6.89545 6 6 6.89543 6 8C6 9.10457 6.89545 10 8 10ZM10 14C10 15.1046 9.10455 16 8 16C6.89545 16 6 15.1046 6 14C6 12.8954 6.89545 12 8 12C9.10455 12 10 12.8954 10 14Z" }) })
	})
});
export default SvgIcThreePointMenu;
